require("!!/Users/edson/projetos_react/anteros-react/node_modules/script-loader/addScript.js")(require("!!/Users/edson/projetos_react/anteros-react/node_modules/raw-loader/index.js!/Users/edson/projetos_react/anteros-react/node_modules/babel-loader/lib/index.js??ref--0!/Users/edson/projetos_react/anteros-react/src/components/AnterosPivot.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/components/AnterosPivot.js
// module id = 1465
// module chunks = 0